import React from 'react';
import { List, Typography } from 'antd';
import { FileText, FolderOpen } from 'lucide-react';
import type { SearchResult } from './types';

const { Text } = Typography;

interface Props {
  results: SearchResult[];
  selectedIndex: number;
  onSelect: (result: SearchResult) => void;
}

export const SearchResults: React.FC<Props> = ({ results, selectedIndex, onSelect }) => {
  return (
    <List
      dataSource={results}
      renderItem={(result, index) => (
        <List.Item
          className={`cursor-pointer hover:bg-gray-50 px-4 py-3 ${
            index === selectedIndex ? 'bg-primary/5' : ''
          }`}
          onClick={() => onSelect(result)}
        >
          <div className="flex items-center gap-3">
            {result.type === 'item' ? (
              <FileText className="h-5 w-5 text-gray-400" />
            ) : (
              <FolderOpen className="h-5 w-5 text-gray-400" />
            )}
            <div className="flex-1 min-w-0">
              {result.type === 'item' ? (
                <>
                  <div className="flex items-center gap-2">
                    <Text className="font-mono">{result.code}</Text>
                    <Text strong className="truncate">{result.name}</Text>
                  </div>
                  {result.groupName && (
                    <Text type="secondary" className="text-sm">
                      in {result.groupName}
                    </Text>
                  )}
                </>
              ) : (
                <Text strong>{result.name}</Text>
              )}
            </div>
          </div>
        </List.Item>
      )}
    />
  );
};